<template>
  <div class="indexAdminLogin_LoginInput_class_div_img">
    <img src="@/assets/indexLogin_Code.png" alt="" @click="gotoCode">
  </div>
  <div class="indexAdminLogin_LoginInput_class_div_top">
    <el-image
        v-if="systemMetaBaseData.systemLogo !==null"
        :src="systemMetaBaseData.systemLogo.systemFileUrl"
        fit="fill"
    />

    <div class="indexAdminLogin_LoginInput_class_title">
      欢迎使用{{ systemMetaBaseData.systemName }}
    </div>
  </div>
  <div class="indexAdminLogin_LoginInput_class_input">
    <el-form ref="formDataRef" :model="formData" :rules="rules" label-position="top" size="large">
      <el-form-item prop="lesseeUserPhone">
        <el-input placeholder="手机号" v-model="formData.lesseeUserPhone" @keyup.enter="accountLogin" clearable  maxlength="11">
          <template #prefix>
            <el-icon color="#007CF4">
              <Iphone/>
            </el-icon>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="systemCodeValue">
        <el-input v-model="formData.systemCodeValue" maxlength="6" placeholder="短信验证码">
          <template #append>
            <el-button style="width:120px;color:#409eff" round link size="small" v-show="!smsSendData.smsSendState"
                       v-on:click="sendLoginSMSCode">获取验证码
            </el-button>
            <el-button style="width:120px" round link size="small" v-show="smsSendData.smsSendState">
              {{ smsSendData.smsSendTime }} s
            </el-button>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item prop="verifyCode">
        <el-input placeholder="图形验证码" v-model="formData.verifyCode" maxlength="4" @keyup.enter="accountLogin">
          <template #append>
            <el-image :src="formData.verifyCodeImg" @click="getVerifyCode"
                      class="indexAdminLogin_LoginInput_class_input_img_code"/>
          </template>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="formData.checked1" style="margin-right: 10px;" size="large"></el-checkbox>
        <span style="color: #000;">我已阅读并同意</span><span
          class="privacyAndService" v-on:click="privacyCilck">隐私政策、</span><span class="privacyAndService"
                                                                                    v-on:click="serviceCilck">服务协议</span>

      </el-form-item>

      <el-form-item>
        <div class="indexAdminLogin_LoginInput_class_button" v-on:click="accountLogin">
          登 录
        </div>
      </el-form-item>
    </el-form>

    <!--    详情弹框-->
    <el-drawer modal-class="modal_" :with-header="false" :append-to-body="true"
               v-model="dialogData.showPrivacyDialogFormVisible" :closeOnClickModal="false" :closeOnPressEscape="false"
               size="100%">
      <indexDataPrivacyShow v-on:childMethod="closeDialog" ref="indexDataPrivacyShowRef"/>
    </el-drawer>


    <!--    详情弹框-->
    <el-drawer modal-class="modal_" :with-header="false" :append-to-body="true"
               v-model="dialogData.showServiceDialogFormVisible" :closeOnClickModal="false" :closeOnPressEscape="false"
               size="100%">
      <indexDataServiceShow v-on:childMethod="closeDialog" ref="indexDataServiceShowRef"/>
    </el-drawer>
    <!-- 未选弹窗 -->
    <el-dialog append-to-body v-model="dialogData.dialogVisible" title="隐私政策及服务协议" width="30%">
      <div>
        我已阅读并同意<span class="privacyAndService" v-on:click="privacyCilck">隐私政策、</span><span
          class="privacyAndService"
          v-on:click="serviceCilck">服务协议</span>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogData.dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="dialogVisibleClick">
            同意
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {onMounted, reactive, ref, nextTick, defineEmits} from 'vue'
import {requestNoToken} from '@/util/adminRequest.js'
import store from '@/configure/store'
import indexDataPrivacyShow from '@/pages/baseModule/indexCmsArticle/Data/DataShowPrivacy'
import indexDataServiceShow from '@/pages/baseModule/indexCmsArticle/Data/DataShowService'
// 返回上级调用参数
const emits = defineEmits(['childMethod'])
import md5 from 'js-md5'
import router from '@/configure/router'
import {validate} from "@/util/validate";

//系统基础数据
const systemMetaBaseData = store.state.systemMetaBaseData

// 插件ref
const indexDataServiceShowRef = ref(null)
const indexDataPrivacyShowRef = ref(null)

const closeDialog = () => {
  dialogData.showPrivacyDialogFormVisible = false
  dialogData.showServiceDialogFormVisible = false
}
const dialogVisibleClick = () => {
  dialogData.dialogVisible = false
  formData.checked1 = true
}
// 初始值
const formData = reactive(
    {
      checked1: false,
      systemCodeValue: '', // 验证码
      lesseeUserPhone: '', // 手机号
      // adminUserPassword: '', // 密码
      verifyCodeImg: '', // 图形验证码
      verifyKey: '', // 验证标识
      verifyCode: '' // 图形验证码
    }
)

//对话框数据
const dialogData = reactive({
  showPrivacyDialogFormVisible: false,  //隐私条款对话框
  showServiceDialogFormVisible: false, //系统协议对话框
  dialogVisible: false
})

// 发送短信数据
const smsSendData = reactive({
  smsSendState: false,  // 短信发送状态
  smsSendTime: 0,  // 短信发送倒计时
  timer: null  // 定时器
})

// 表单ref
const formDataRef = ref(null)

// 校验
const rules = reactive({
  lesseeUserPhone: [
    {required: true, message: '请输入手机号', trigger: 'blur'},
    {pattern: validate.phone, message: '手机号格式不正确，请重新输入', trigger: 'blur'}
  ],
  systemCodeValue: [
    {required: true, message: '请输入验证码', trigger: 'blur'}
  ],
  verifyCode: [
    {required: true, message: '请输入图形验证码', trigger: 'blur'}
  ]
})
//跳转到扫码登录
const gotoCode = function () {
  emits('childMethod', 'SMSLogin', "")
}
//显示添加企业
const addLesseeClick=function (){
  emits('childMethod', 'addLessee', "")
}
// // 获取图片验证码
const getVerifyCode = function () {
  requestNoToken({
    url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/GetVerifyCode',
    data: {}
  }).then(res => {
    formData.verifyCodeImg = res.data.verifyCodeImg
    formData.verifyKey = res.data.verifyKey
  })
}

// 管理员用户账户登录
const accountLogin = function () {

  formDataRef.value.validate((valid) => {
    if (valid) {
      if (!formData.checked1) {
        dialogData.dialogVisible = true
        return false
      }
      requestNoToken({
        url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/AccountLogin',
        data: {
          lesseeUserPhone: formData.lesseeUserPhone,
          // adminUserPassword: md5(formData.adminUserPassword),
          // adminUserPassword: formData.adminUserPassword,
          systemCodeValue: formData.systemCodeValue,
          verifyCode: formData.verifyCode,
          verifyKey: formData.verifyKey
        }
      }).then(res => {
        store.commit('saveUserData', {
          lesseeManageToken: res.data.lesseeManageToken,
          lesseeManageData: res.data.lesseeManageData
        })
        emits('childMethod', 'selectLessee', "")
      })
      nextTick(() => {
        getVerifyCode()
      })
    }
  })
}

// 发送短信验证码
const sendLoginSMSCode = function () {
    if (validate.phone.test(formData.lesseeUserPhone) == false) {
        return;
    }
  requestNoToken({
    url: '/Api/userSystem/LesseeMainModule/LesseeMainUserLogin/SendSSMCode',
    data: {
      'systemCodeKey': formData.lesseeUserPhone
    }
  }).then(res => {
    setSMSSendNum()
  })
}

// 隐私政策
const privacyCilck = function (data) {
  console.log(1)
  dialogData.showPrivacyDialogFormVisible = true
  nextTick(() => {
    indexDataPrivacyShowRef.value.getOneData()
  })
  // emits('childMethod', 'showDataClick', data.systemPrivacyPolicyID)
}


// 服务协议
const serviceCilck = function (data) {
  console.log(2)
  // 编辑详细数据
  dialogData.showServiceDialogFormVisible = true
  nextTick(() => {
    indexDataServiceShowRef.value.getOneData()
  })
  // emits('childMethod', 'showDataClick', data.systemPrivacyPolicyID)
}


// 短信验证码数字
const setSMSSendNum = function () {
  // 验证手机号
  const TIME_COUNT = 60
  if (!smsSendData.timer) {
    smsSendData.smsSendTime = TIME_COUNT
    smsSendData.smsSendState = true
    smsSendData.timer = setInterval(() => {
      if (smsSendData.smsSendTime > 0 && smsSendData.smsSendTime <= TIME_COUNT) {
        smsSendData.smsSendTime--
      } else {
        smsSendData.smsSendState = false
        clearInterval(smsSendData.timer) // 清除定时器
        smsSendData.timer = null
      }
    }, 1000)
  }
}

// 启动调用
onMounted(() => {
  getVerifyCode()
})
</script>
<style scoped>
.indexAdminLogin_LoginInput_class_button {
  background: #409eff;
  border-radius: 2px;
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #007CF4;
  border-color: #007CF4;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000;
}
</style>
